// src/pages/sampleGroupProfiles.js
const sampleGroups = [
  {
    facilityName: "St. Mary's Medical Center",
    location: "Philadelphia, PA",
    contactPerson: {
      name: "Dr. John Doe",
      email: "j.doe@stmarys.org",
      phone: "+1 512-555-0198"
    },
    coverageNeeds: {
      startDate: "2025-01-01",
      scheduleType: "Full-Time",
      duration: "3 months",
      shiftTimes: "7am–3pm",
      onCall: false,
      weekends: false,
      estimatedWeeklyHours: 40
    },
    clinicalExpectations: {
      requiredCaseTypes: ["OB", "General Surgery", "Orthopedics"],
      regionalAnesthesia: ["Epidurals", "Spinals"],
      emrSystem: "Epic"
    },
    facilityDetails: {
      facilityType: "Hospital",
      bedCount: "300+",
      traumaLevel: "Level II",
      teamModel: "Medical supervision"
    },
    compensation: {
      rateRange: "$200–$240/hr",
      w2Or1099: "1099",
      includesHousing: true,
      includesTravel: true,
      malpracticeCovered: true
    },
    additionalNotes: "Looking for CRNAs comfortable with OB and flexible with day-to-day case mix."
  },
  {
    facilityName: "Northwest Surgical Institute",
    location: "Scranton, PA",
    contactPerson: {
      name: "Barbara Barnes",
      email: "bbarnes@nwsi.com",
      phone: "+1 555-555-2244"
    },
    coverageNeeds: {
      startDate: "2025-02-15",
      scheduleType: "Part-Time",
      duration: "6 months",
      shiftTimes: "7am–1pm",
      onCall: false,
      weekends: false,
      estimatedWeeklyHours: 20
    },
    clinicalExpectations: {
      requiredCaseTypes: ["ENT", "Plastics", "Urology"],
      regionalAnesthesia: ["Peripheral nerve blocks"],
      emrSystem: "Cerner"
    },
    facilityDetails: {
      facilityType: "Ambulatory Surgery Center",
      bedCount: "N/A",
      traumaLevel: "Not Applicable",
      teamModel: "Independent practice"
    },
    compensation: {
      rateRange: "$210–$250/hr",
      w2Or1099: "W2",
      includesHousing: false,
      includesTravel: false,
      malpracticeCovered: true
    },
    additionalNotes: "Ideal for CRNAs who enjoy lighter outpatient procedures in a team-oriented environment."
  },
  {
    facilityName: "Lakeside Regional Hospital",
    location: "Pittsburgh, PA",
    contactPerson: {
      name: "Dr. Kyle Smith",
      email: "k.smith@lakeside.org",
      phone: "+1 555-555-9988"
    },
    coverageNeeds: {
      startDate: "2025-03-01",
      scheduleType: "Full-Time",
      duration: "Permanent",
      shiftTimes: "Flexible",
      onCall: true,
      weekends: true,
      estimatedWeeklyHours: 36
    },
    clinicalExpectations: {
      requiredCaseTypes: ["Neuroanesthesia", "Cardiac", "Trauma"],
      regionalAnesthesia: ["Spinals", "Peripheral nerve blocks"],
      emrSystem: "Meditech"
    },
    facilityDetails: {
      facilityType: "Hospital",
      bedCount: "400+",
      traumaLevel: "Level I",
      teamModel: "Medical Direction"
    },
    compensation: {
      rateRange: "$230–$275/hr",
      w2Or1099: "1099",
      includesHousing: true,
      includesTravel: true,
      malpracticeCovered: false
    },
    additionalNotes: "We need strong CRNAs for high acuity cases in a fast-paced setting. Call coverage required."
  },
//   {
//     facilityName: "Blue Ridge Anesthesia Group",
//     location: "Asheville, NC",
//     contactPerson: {
//       name: "Linda Torres",
//       email: "linda.torres@bragroup.com",
//       phone: "+1 828-555-0134"
//     },
//     coverageNeeds: {
//       startDate: "2025-05-10",
//       scheduleType: "PRN",
//       duration: "Ongoing",
//       shiftTimes: "Varies",
//       onCall: false,
//       weekends: false,
//       estimatedWeeklyHours: 16
//     },
//     clinicalExpectations: {
//       requiredCaseTypes: ["Dental", "Ophthalmology"],
//       regionalAnesthesia: [],
//       emrSystem: "Paper Charting"
//     },
//     facilityDetails: {
//       facilityType: "Office-Based Practice",
//       bedCount: "N/A",
//       traumaLevel: "Not Applicable",
//       teamModel: "Independent practice"
//     },
//     compensation: {
//       rateRange: "$250–$280/hr",
//       w2Or1099: "1099",
//       includesHousing: false,
//       includesTravel: true,
//       malpracticeCovered: false
//     },
//     additionalNotes: "Seeking a reliable CRNA for light outpatient sedation cases in a low-stress setting."
//   },
//   {
//     facilityName: "Tri-State Medical Network",
//     location: "Jersey City, NJ",
//     contactPerson: {
//       name: "Michael Cheng",
//       email: "m.cheng@tristatenetwork.org",
//       phone: "+1 201-555-7788"
//     },
//     coverageNeeds: {
//       startDate: "2025-04-20",
//       scheduleType: "Full-Time",
//       duration: "12 weeks",
//       shiftTimes: "6am–2pm",
//       onCall: true,
//       weekends: false,
//       estimatedWeeklyHours: 40
//     },
//     clinicalExpectations: {
//       requiredCaseTypes: ["General Surgery", "Orthopedics", "Endoscopy"],
//       regionalAnesthesia: ["Epidurals"],
//       emrSystem: "Athena"
//     },
//     facilityDetails: {
//       facilityType: "Hospital",
//       bedCount: "250–300",
//       traumaLevel: "Level III",
//       teamModel: "Medical supervision"
//     },
//     compensation: {
//       rateRange: "$220–$260/hr",
//       w2Or1099: "W2",
//       includesHousing: true,
//       includesTravel: true,
//       malpracticeCovered: true
//     },
//     additionalNotes: "Reliable housing provided within 15 minutes of the hospital. CRNAs must be comfortable with diverse case loads."
//   }
];

export default sampleGroups;
